import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const buy_responseApi = createAsyncThunk(
  "buy_response",
  async ({ name = "", startDate = null, endDate = null }) => {
    const params = {};
    if (name) {
      params.customerName = name;
    }
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    const response = await axiosInstance.get("/buy_response", { params });
    // console.log("customerName", response.data);
    // console.log("params data", params);

    return response.data;
  },
);

const buy_responseSlice = createSlice({
  name: "buy_response",
  initialState: {
    buy_response: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(buy_responseApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(buy_responseApi.fulfilled, (state, action) => {
        state.buy_response = action.payload;
        state.loading = false;
      })
      .addCase(buy_responseApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default buy_responseSlice.reducer;
